import React, { cloneElement } from 'react'
import classnames from 'classnames'

export interface OnboardingStepsProps {
  className?: string
  children: Array<React.ReactElement<any, string | React.JSXElementConstructor<any>> | null>
}

export const OnboardingSteps: React.FC<OnboardingStepsProps> = (props) => {
  const validChildren = props.children.filter(Boolean)
  const lastActiveIndex = validChildren.length - 1 - validChildren
    .slice()
    .reverse()
    .findIndex((c: any) => c.props.isActive)

  const children = validChildren.map((OnboardingStep: any, i: number) => {
    const stepIsActive = !!OnboardingStep.props.isActive
    return cloneElement(OnboardingStep, {
      key: i,
      number: i + 1,
      isComplete: stepIsActive && i < lastActiveIndex,
      isActive: stepIsActive && i === lastActiveIndex,
      isIncomplete: !stepIsActive,
    })
  })

  return <div className={classnames(props.className)}>{children}</div>
}

export default OnboardingSteps
